import {Button, H4} from '@hm/fundamental'
import {AssetConfigurationDto} from '@kilnfeature/types'
import {mdiPlus} from '@mdi/js'
import {useFieldArray, useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {DrillingZonesChart} from './DrillingZonesChart'
import {DrillingZonesTable} from './DrillingZonesTable'

import {DRILLING_SETTINGS_CANVAS_HEIGHT} from '@refra/modules/refra-planning/components/KilnOverviewCard/Drilling/DrillingSettings/DrillingZones/helpers'
import {DrillingZone} from '@refra/modules/refra-planning/types'

export const DrillingZones = ({kilnConfig}: {kilnConfig: AssetConfigurationDto}) => {
  const {t} = useTranslation()

  const {control, getValues, setValue} = useFormContext<{drillingZones: DrillingZone[]}>()
  const kilnLength = Number(kilnConfig.payload.configuration.dimensions.length)
  const {fields, append, remove} = useFieldArray<{drillingZones: DrillingZone[]}, 'drillingZones'>({
    control,
    name: 'drillingZones'
  })

  const addDrillingZone = () => {
    const currentDrillingZones = getValues().drillingZones
    const lastZoneIndex = currentDrillingZones.length - 1
    const zone = currentDrillingZones[lastZoneIndex]
    setValue(`drillingZones.${lastZoneIndex}.toMeter`, zone.toMeter - 1)
    append({
      name: '',
      fromMeter: kilnLength - 1,
      toMeter: kilnLength,
      threshold: 0
    })
  }

  return (
    <div>
      <div className="flex w-full justify-between items-center mb-24px mt-3">
        <H4 data-test-id="drilling_zones_title">{t('plantSetup.drillingZone.thresholds')}</H4>
        <Button
          variant={'secondary'}
          icon={mdiPlus}
          onClick={() => addDrillingZone()}
          data-test-id="add_drilling_zone_btn"
        >
          {t('plantSetup.drillingZone.addThreshold')}
        </Button>
      </div>
      <div>
        <div className="mb-24px">
          <DrillingZonesChart
            kilnConfig={kilnConfig}
            canvasRowHeight={DRILLING_SETTINGS_CANVAS_HEIGHT}
          />
        </div>
        <DrillingZonesTable fields={fields} remove={remove} kilnLength={kilnLength} />
      </div>
    </div>
  )
}
